export enum NetworkErrorType {
  SERVER_DOWN = 'SERVER_DOWN',
  CLIENT_CONNECTION_DOWN = 'CLIENT_CONNECTION_DOWN',
}

export type NetworkErrorSlice = {
  hasNetworkError: boolean,
  networkErrorType: NetworkErrorType | null
}
